import { ISelectOption } from 'app/interfaces/ISelectOption';
import { format } from 'app/shared/utils/string.util';
import { DataFlowJoinMatchType } from './dataflow-joinmatchtype';

export type DataFlowJoinType = 'inner' | 'outer' | 'left' | 'right' | 'cross';

export function getDataflowJoinTypeOptions(matchType: DataFlowJoinMatchType = 'exact'): Array<ISelectOption<DataFlowJoinType>> {
    return [
        {
            label: stringResources.DataFlowJoinType_Outer,
            labelIcon: 'svg-join-outer',
            value: 'outer',
            title: stringResources.DataFlowJoinType_Outer_Description
        },
        {
            label: stringResources.DataFlowJoinType_Inner,
            labelIcon: 'svg-join-inner',
            value: 'inner'
        },
        {
            label: stringResources.DataFlowJoinType_LeftOuter,
            labelIcon: 'svg-join-left-outer',
            value: 'left'
        },
        {
            label: stringResources.DataFlowJoinType_RightOuter,
            labelIcon: 'svg-join-right-outer',
            value: 'right',
            disabled: matchType === 'fuzzy',
            disabledTooltip: format(stringResources.DataFlowJoinFuzzyDisabled, stringResources.DataFlowJoinType_RightOuter)
        },
        {
            label: stringResources.DataFlowJoinType_Cross,
            labelIcon: 'svg-join-cross',
            value: 'cross',
            disabled: matchType === 'fuzzy',
            disabledTooltip: format(stringResources.DataFlowJoinFuzzyDisabled, stringResources.DataFlowJoinType_Cross)
        }
    ];
}

export function getJoinTypeString(joinType: DataFlowJoinType): string {
    switch (joinType) {
        case 'inner':
            return stringResources.DataFlowJoinType_Inner;
        case 'outer':
            return stringResources.DataFlowJoinType_Outer;
        case 'left':
            return stringResources.DataFlowJoinType_LeftOuter;
        case 'right':
            return stringResources.DataFlowJoinType_RightOuter;
        case 'cross':
            return stringResources.DataFlowJoinType_Cross;
        default:
            return '';
    }
}
